import React from "react";
import { MotionConfig } from "framer-motion";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { MethodSection } from "./components/MethodSection";
import { AudienceSection } from "./components/AudienceSection";
import { ContentsSection } from "./components/ContentsSection";
import { DifferenceSection } from "./components/DifferenceSection";
import { BonusSection } from "./components/BonusSection";
import { OfferSection } from "./components/OfferSection";
import { PromiseSection } from "./components/PromiseSection";
import { FinalCta } from "./components/FinalCta";
import { Footer } from "./components/Footer";
export function App() {
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="2wjqhr811w6n6">
      <div className="min-h-screen w-full bg-ink font-sans text-cream" data-id="element-1" data-mp="2wip54z4dzc3c">
        <Header data-id="element-2" data-mp="28te37ebavbnm" />
        <main data-id="element-3" data-mp="28suveqfd63nb">
          <Hero data-id="element-4" data-mp="28sbbx5a2f776" />
          <MethodSection data-id="element-5" data-mp="23vcjqs9ypabm" />
          <AudienceSection data-id="element-6" data-mp="23w4fq47h1a2f" />
          <ContentsSection data-id="element-7" data-mp="23utcc5hxu4bu" />
          <DifferenceSection data-id="element-8" data-mp="23ti8y6semyl9" />
          <BonusSection data-id="element-9" data-mp="3ikh7o8icgqyg" />
          <OfferSection data-id="element-10" data-mp="3iiwasc8k4vxf" />
          <PromiseSection data-id="element-11" data-mp="3ijpe138b53at" />
          <FinalCta data-id="element-12" data-mp="3mlj82snzz920" />
        </main>
        <Footer data-id="element-13" data-mp="3mkhmhu9cv461" />
      </div>
    </MotionConfig>;
}